import { useQuery } from '@tanstack/react-query'

import { getMerchantOrganizationUserAccountYearMonthSummary } from '@src/api'
import { DefaultApiGetMerchantOrganizationUserAccountYearMonthSummaryRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchMerchantOrganizationUserAccountYearMonthSummary = (
  params: DefaultApiGetMerchantOrganizationUserAccountYearMonthSummaryRequest
) => {
  const { axiosInstance } = useAxios()
  const { data, isError, isLoading, refetch } = useQuery({
    enabled:
      !!params.organizationId &&
      !!params.merchantId &&
      !!params.userAccountId &&
      !!params.toYearMonth,
    queryFn: () =>
      getMerchantOrganizationUserAccountYearMonthSummary(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_MERCHANT_ORGANIZATION_USER_ACCOUNT_YEAR_MONTH_SUMMARY,
      params.organizationId,
      params.merchantId,
      params.userAccountId,
      params.fromYearMonth,
      params.toYearMonth,
    ],
  })

  return { data, isError, isLoading, refetch }
}
